import { DATE_FORMAT } from "../../Utils/date_utils";
import { INITIALIZE_STORE } from "../actions/manager.actions";
import {
	STATUS_TRACKER_SET_CELL_LOADING,
	STATUS_TRACKER_SET_DATA,
	STATUS_TRACKER_SET_FILTER,
	STATUS_TRACKER_SET_CUSTOM_STATUS_DATA,
	STATUS_TRACKER_SET_AVAILABLE_STATUS_DATA,
	STATUS_TRACKER_SET_MODAL_LOADING,
	STATUS_TRACKER_FLAG_METADATA
} from "../actions/statustracker.actions";
import dayjs from "dayjs";

const initialState = {
	cellLoading: {},
	trackerData: {},
	flagMetadata: {},
	statuses: [],
	filters: {
		playersFilter : [],
		positionsFilter: [],
		playerGroupsFilter: [],
		selectedMonth: dayjs(),
		playerStatusesFilter: []
	},
	modalLoading: {}
};

export const statusTrackerReducer = (state = initialState, action) => {
	switch (action.type) {
		case STATUS_TRACKER_SET_CELL_LOADING:
			return { ...state, cellLoading: {...state.cellLoading, ...action.data} };
		case STATUS_TRACKER_SET_MODAL_LOADING:
			return { ...state, modalLoading: {...state.modalLoading, ...action.data} };
		case STATUS_TRACKER_FLAG_METADATA:
			return { ...state, flagMetadata: {...state.flagMetadata, ...action.data} };
		case STATUS_TRACKER_SET_DATA:
			return { ...state, trackerData: {...state.trackerData, ...action.data} };
		case STATUS_TRACKER_SET_FILTER:
			return { ...state, filters: { ...state.filters, ...action.data } };
		case STATUS_TRACKER_SET_AVAILABLE_STATUS_DATA:
			return { ...state, statuses: action.data };
		case STATUS_TRACKER_SET_CUSTOM_STATUS_DATA:
			const uniquekey = action.data[0];
			let uniquekeyDict = state.trackerData[uniquekey];
			let updatedVal = { ...state.trackerData, [uniquekey]: {...uniquekeyDict, 'status': action.data[1]}};
			return { ...state, trackerData: updatedVal };
		case INITIALIZE_STORE:
				return initialState;
		default:
			return state;
	}
};
